import { useEffect } from 'react';

// 要素が十分スクロールインしてから発火。rootMargin で開始位置を遅らせる
export const SCROLL_FADE_IN_OPTIONS = {
  threshold: 0.2,
  rootMargin: '0px 0px -20% 0px',
};

export function useScrollFadeIn(sectionRef, selector, deps = []) {
  useEffect(() => {
    const container = sectionRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      SCROLL_FADE_IN_OPTIONS
    );

    container.querySelectorAll(selector).forEach((el) => observer.observe(el));

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
